function roPluralizationRules(
    choice,
    choicesLength

) {
    if (choice === 0) {
        return 0
    }

    if (choice === 1) {
        return 1
    }


    if (choice > 1) {
        return 2
    }
    return choicesLength < 4 ? 2 : 3
}

function enPluralizationRules(
    choice,
    choicesLength

) {
    if (choice === 0) {
        return 0
    }

    if (choice === 1) {
        return 1
    }


    if (choice > 1) {
        return 2
    }
    return choicesLength < 4 ? 2 : 3
}


export default {
    ro: roPluralizationRules,
    en: enPluralizationRules
};